import { render, staticRenderFns } from "./VehicleData.vue?vue&type=template&id=880a38da&scoped=true"
import script from "./VehicleData.vue?vue&type=script&lang=js"
export * from "./VehicleData.vue?vue&type=script&lang=js"
import style0 from "./VehicleData.vue?vue&type=style&index=0&id=880a38da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880a38da",
  null
  
)

export default component.exports